import { runTimeConfig } from "~/lib/utils/runtime-config";
import { EVENT_CHANNELS, EVENT_TYPES } from "./analytics.events";
import ReactGA from 'react-ga4';

export const useInit = () => {
  if (runTimeConfig.ANALYTIC.GA.ENABLED) {
    ReactGA.initialize(runTimeConfig.ANALYTIC.GA.TRACKING_ID);
  }
  useInitMixPanel();
};

const useInitMixPanel = async () => {
  const { default: mixpanel } = await import('mixpanel-browser');
  if (runTimeConfig.ANALYTIC.MIXPANEL.ENABLED) {
    mixpanel.init(
      runTimeConfig.ANALYTIC.MIXPANEL.TOKEN,
      process.env.NODE_ENV === 'development'
        ? {
          debug: true,
          verbose: true,
          ignore_dnt: true,
        }
        : undefined
    );
  }
};

export async function trackUserEvent(
  eventName: EVENT_TYPES,
  meta?: { [key: string]: any },
  channels: EVENT_CHANNELS[] = [
    EVENT_CHANNELS.MIXPANEL,
    EVENT_CHANNELS.GA,
  ]
) {
  try {
    const { MIXPANEL, GA } = runTimeConfig.ANALYTIC;

    if (channels.includes(EVENT_CHANNELS.GA)) {
      if (!GA.ENABLED) return;
      ReactGA.event(eventName, meta);
    }

    if (channels.includes(EVENT_CHANNELS.MIXPANEL)) {
      if (!MIXPANEL.ENABLED) return;
      const mixpanel = await import('mixpanel-browser');
      mixpanel.track(eventName, meta);
    }

  } catch (err) {
    console.error('analytics:', err);
  }
}